/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Gateway Swagger API
 * OpenAPI spec version: 1.2
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  DtoAuthorityToken,
  DtoFidoLogin,
  DtoFidoResponseSuccess,
  DtoHealthSuccess,
  DtoKeepLoggedInRequest,
  DtoOtpLogin,
  DtoOtpLoginSuccess,
  DtoRefresh,
  TokenExchangeRequest,
  TokenExchangeResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 상태체크
 */
export const getApiV1Health = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<DtoHealthSuccess>(
    { url: `/api/v1/health`, method: 'GET', signal },
    options,
  );
};

export const getGetApiV1HealthQueryKey = () => {
  return ['api', 'v1', 'health'] as const;
};

export const getGetApiV1HealthQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiV1Health>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Health>>, TError, TData>>;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetApiV1HealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1Health>>> = ({ signal }) =>
    getApiV1Health(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiV1Health>>,
    TError,
    TData
  >;
};

export type GetApiV1HealthQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1Health>>>;
export type GetApiV1HealthQueryError = ErrorType<unknown>;

/**
 * @summary 상태체크
 */

export function useGetApiV1Health<
  TData = Awaited<ReturnType<typeof getApiV1Health>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Health>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiV1HealthQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * 외부 통합 토큰을 검증하고 내부 액세스, 리프레시, 세션 토큰으로 교환
 * @summary 외부 토큰을 내부 토큰으로 교환
 */
export const postApiV8TokenExchange = (
  tokenExchangeRequest: MaybeRef<TokenExchangeRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  tokenExchangeRequest = unref(tokenExchangeRequest);

  return customAxiosInstance<TokenExchangeResponse>(
    {
      url: `/api/v8/token/exchange`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tokenExchangeRequest,
      signal,
    },
    options,
  );
};

export const getPostApiV8TokenExchangeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiV8TokenExchange>>,
    TError,
    { data: BodyType<TokenExchangeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiV8TokenExchange>>,
  TError,
  { data: BodyType<TokenExchangeRequest> },
  TContext
> => {
  const mutationKey = ['postApiV8TokenExchange'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiV8TokenExchange>>,
    { data: BodyType<TokenExchangeRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiV8TokenExchange(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiV8TokenExchangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiV8TokenExchange>>
>;
export type PostApiV8TokenExchangeMutationBody = BodyType<TokenExchangeRequest>;
export type PostApiV8TokenExchangeMutationError = ErrorType<unknown>;

/**
 * @summary 외부 토큰을 내부 토큰으로 교환
 */
export const usePostApiV8TokenExchange = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiV8TokenExchange>>,
      TError,
      { data: BodyType<TokenExchangeRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postApiV8TokenExchange>>,
  TError,
  { data: BodyType<TokenExchangeRequest> },
  TContext
> => {
  const mutationOptions = getPostApiV8TokenExchangeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 토큰 재발급
 */
export const postApiV1RefreshToken = (
  dtoRefresh: MaybeRef<DtoRefresh>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dtoRefresh = unref(dtoRefresh);

  return customAxiosInstance<string>(
    {
      url: `/api/v1/refresh-token`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dtoRefresh,
      signal,
    },
    options,
  );
};

export const getPostApiV1RefreshTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiV1RefreshToken>>,
    TError,
    { data: BodyType<DtoRefresh> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiV1RefreshToken>>,
  TError,
  { data: BodyType<DtoRefresh> },
  TContext
> => {
  const mutationKey = ['postApiV1RefreshToken'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiV1RefreshToken>>,
    { data: BodyType<DtoRefresh> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiV1RefreshToken(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiV1RefreshTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiV1RefreshToken>>
>;
export type PostApiV1RefreshTokenMutationBody = BodyType<DtoRefresh>;
export type PostApiV1RefreshTokenMutationError = ErrorType<unknown>;

/**
 * @summary 토큰 재발급
 */
export const usePostApiV1RefreshToken = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiV1RefreshToken>>,
      TError,
      { data: BodyType<DtoRefresh> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postApiV1RefreshToken>>,
  TError,
  { data: BodyType<DtoRefresh> },
  TContext
> => {
  const mutationOptions = getPostApiV1RefreshTokenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Fido 로그인
 */
export const postApiV7HyundaiSsoFidoRes = (
  dtoFidoLogin: MaybeRef<DtoFidoLogin>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dtoFidoLogin = unref(dtoFidoLogin);

  return customAxiosInstance<DtoFidoResponseSuccess>(
    {
      url: `/api/v7/hyundai/sso/fido/res`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dtoFidoLogin,
      signal,
    },
    options,
  );
};

export const getPostApiV7HyundaiSsoFidoResMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiV7HyundaiSsoFidoRes>>,
    TError,
    { data: BodyType<DtoFidoLogin> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiV7HyundaiSsoFidoRes>>,
  TError,
  { data: BodyType<DtoFidoLogin> },
  TContext
> => {
  const mutationKey = ['postApiV7HyundaiSsoFidoRes'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiV7HyundaiSsoFidoRes>>,
    { data: BodyType<DtoFidoLogin> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiV7HyundaiSsoFidoRes(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiV7HyundaiSsoFidoResMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiV7HyundaiSsoFidoRes>>
>;
export type PostApiV7HyundaiSsoFidoResMutationBody = BodyType<DtoFidoLogin>;
export type PostApiV7HyundaiSsoFidoResMutationError = ErrorType<unknown>;

/**
 * @summary Fido 로그인
 */
export const usePostApiV7HyundaiSsoFidoRes = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiV7HyundaiSsoFidoRes>>,
      TError,
      { data: BodyType<DtoFidoLogin> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postApiV7HyundaiSsoFidoRes>>,
  TError,
  { data: BodyType<DtoFidoLogin> },
  TContext
> => {
  const mutationOptions = getPostApiV7HyundaiSsoFidoResMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary OTP 로그인
 */
export const postApiV7HyundaiSsoOtp = (
  dtoOtpLogin: MaybeRef<DtoOtpLogin>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dtoOtpLogin = unref(dtoOtpLogin);

  return customAxiosInstance<DtoOtpLoginSuccess>(
    {
      url: `/api/v7/hyundai/sso/otp`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dtoOtpLogin,
      signal,
    },
    options,
  );
};

export const getPostApiV7HyundaiSsoOtpMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiV7HyundaiSsoOtp>>,
    TError,
    { data: BodyType<DtoOtpLogin> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiV7HyundaiSsoOtp>>,
  TError,
  { data: BodyType<DtoOtpLogin> },
  TContext
> => {
  const mutationKey = ['postApiV7HyundaiSsoOtp'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiV7HyundaiSsoOtp>>,
    { data: BodyType<DtoOtpLogin> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiV7HyundaiSsoOtp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiV7HyundaiSsoOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiV7HyundaiSsoOtp>>
>;
export type PostApiV7HyundaiSsoOtpMutationBody = BodyType<DtoOtpLogin>;
export type PostApiV7HyundaiSsoOtpMutationError = ErrorType<unknown>;

/**
 * @summary OTP 로그인
 */
export const usePostApiV7HyundaiSsoOtp = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiV7HyundaiSsoOtp>>,
      TError,
      { data: BodyType<DtoOtpLogin> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postApiV7HyundaiSsoOtp>>,
  TError,
  { data: BodyType<DtoOtpLogin> },
  TContext
> => {
  const mutationOptions = getPostApiV7HyundaiSsoOtpMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 세션 토큰을 사용하여 새로운 인증 토큰들을 발급받습니다
 * @summary 로그인 유지 (Keep logged in)
 */
export const postApiV7KeepLogged = (
  dtoKeepLoggedInRequest: MaybeRef<DtoKeepLoggedInRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dtoKeepLoggedInRequest = unref(dtoKeepLoggedInRequest);

  return customAxiosInstance<DtoAuthorityToken>(
    {
      url: `/api/v7/keep-logged`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dtoKeepLoggedInRequest,
      signal,
    },
    options,
  );
};

export const getPostApiV7KeepLoggedMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiV7KeepLogged>>,
    TError,
    { data: BodyType<DtoKeepLoggedInRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiV7KeepLogged>>,
  TError,
  { data: BodyType<DtoKeepLoggedInRequest> },
  TContext
> => {
  const mutationKey = ['postApiV7KeepLogged'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiV7KeepLogged>>,
    { data: BodyType<DtoKeepLoggedInRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiV7KeepLogged(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiV7KeepLoggedMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiV7KeepLogged>>
>;
export type PostApiV7KeepLoggedMutationBody = BodyType<DtoKeepLoggedInRequest>;
export type PostApiV7KeepLoggedMutationError = ErrorType<unknown>;

/**
 * @summary 로그인 유지 (Keep logged in)
 */
export const usePostApiV7KeepLogged = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiV7KeepLogged>>,
      TError,
      { data: BodyType<DtoKeepLoggedInRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postApiV7KeepLogged>>,
  TError,
  { data: BodyType<DtoKeepLoggedInRequest> },
  TContext
> => {
  const mutationOptions = getPostApiV7KeepLoggedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
